var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"pdf"},[_c('iframe',{attrs:{"src":_vm.fileUrl,"frameborder":"0","width":"100%","height":"600px","border":"0","marginwidth":"0","marginheight":"0","scrolling":"no","allowtransparency":"yes"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }